import { useLocation, useResolvedPath } from "react-router-dom";

/**
 * Retorna o path utilizado para navegação pelo react-router relativo à rota associada ao componente.
 */
export const useRelativePath = () => {
    const a = useResolvedPath("")
    const b = useLocation();

    const root = a.pathname
    const sub = b.pathname.slice(root.length)

    return [
        root,
        sub === "" ? "/" : ("/" + sub.replace(/\/+$/, "")).replace(/^\/+/, "/")
    ]

}